import { semanticColors } from "~/common/colors/colors";

export const StatusColor = {
    None: {
        border: semanticColors.warning.border.light,
        user: semanticColors.warning.icon.light,
    },
    Approved: {
        border: semanticColors.success.border.light,
        user: semanticColors.success.icon.light,
    },
    Rejected: {
        border: semanticColors.error.border.light,
        user: semanticColors.error.icon.light,
    },
};

export enum ApproverStatus {
    None = "None",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ApprovalMessageStatus {
    approval = "approval",
    approved = "approved",
    rejected = "rejected",
    outdated = "outdated",
}

export enum MessageTypes {
    ApprovalApproved = "ApprovalApproved",
    ApprovalRejected = "ApprovalRejected",
    AllocationApproved = "AllocationApproved",
    AllocationRejected = "AllocationRejected",
}
